import { render } from "./PanelMetadata.vue?vue&type=template&id=10cb3947&ts=true"
import script from "./PanelMetadata.vue?vue&type=script&lang=ts"
export * from "./PanelMetadata.vue?vue&type=script&lang=ts"

import "./PanelMetadata.vue?vue&type=style&index=0&id=10cb3947&lang=scss"

import exportComponent from "/codebuild/output/src602189598/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__